import dayjs from 'dayjs';
import io from 'socket.io-client';
import dayjsPluginUTC from 'dayjs/plugin/utc'
import configData from "../config.json";


let socket = null;

export const initSocket = () => {
    const socketServer = configData.SOCKET_SERVER_URL;
    socket =  io(socketServer, { 
        path: '/websocket',
    });
    return socket;
}

// export const setSocket = (socketInstance) => {
//     socket = socketInstance;
//     return socket;
// }

export const getSocket = () => {
    socket =  initSocket();
    return socket;
}

export const connectSocket = (recipientId) => {
    socket.on('connect',() => {
        sessionSubscribe(recipientId)
    })
}

export const sessionSubscribe = (recipientId) => {
    //console.log('recipientId',recipientId)
    socket.emit('subscribe',recipientId)
}

export const sessionConnectionRequest = (callback) => {
    socket.on('session_connection_request',(response) => {
        callback(response);
    })
}


export const sessionConnectionRequestTimeOut = (callback) => {
    socket.on('session_connection_request_timeout',(response) => {
        callback(response);
    })
}

export const sessionConnectionRequestClosed = (callback) => {
    socket.on('session_connection_request_closed',(response) => {
        callback(response);
    })
}

export const sessionUnSubscribe = (recipientId) => {
    socket.emit('unsubscribe',recipientId)
}

export const sessionRequestEmitClosed = (requestData) => {
    socket.emit('session_connection_request_closed',requestData)
}

export const sessionRequestAccepted = (requestData) => {
    socket.emit('session_connection_request_accepted',requestData)
}

export const sessionDisconnect = () => {
    socket.disconnect();
}

export const sendAcknowldegeToSocket = (requestData) => {
    socket.emit('acknowledgement', requestData);
};


export const acknowledgeRequest = (callback) => {
    socket.on('acknowledgement',(response) => {
        callback(response);
    })
};

export const requestInitialPayload = (requestData) => {
    sendCommandToSocket(requestData)
};

export const sendCommandToSocket = (requestData) => {
    socket.emit('command', requestData);
};

export const updatedDataRequest = (callback) => {
    socket.on('data_update',(response) => {
        callback(response);
    })
};


export const sendMessageToRecipient = (requestData) => {
    socket.emit('chat_messages', requestData);
};

export const chatMessagesRequest = (callback) => {
    socket.on('chat_messages',(response) => {
        callback(response);
    })
};

export const eventsRequest = (callback) => {
    socket.on('events',(response) => {
        callback(response);
    })
};


export const changeLogsRequest = (callback) => {
    socket.on('change_logs',(response) => {
        callback(response);
    })
};

export const typingRequest = (callback) => {
    socket.on('typing',(response) => {
        callback(response);
    })
};

export const userLeftSession = (callback) => {
    socket.on('user_left',(response) => {
        callback(response);
    })
}

export const socketPingPongMessages = () => {
    socket.on('ping',() => {
        //console.log('received ping from server');
        socket.emit('pong');
    })
}

export const socketDisconnect = (callback) => {
    socket.on('disconnect',(response) => {
        callback(response);
    })
}

export const createChatMessage = (serialNumber,message) => {
    let chatMessage = {
        "recipientId": serialNumber,
        "data": {
            "timestamp": currentDateTime(),
            "message": {
                "type": "chat_message",
                "data": {
                    "action_info": "get",
                    "entity": {
                        "message_text": message,
                        'sender':'web_client',
                        'receiver':'app_client',
                        'timestamp': currentDateTime(),
                    }
                }
            },
        }
    }
    sendMessageToRecipient(chatMessage);
}


export const requestInitialFileData = (recipientId) => {
    let requestData = {
        "recipientId": recipientId,
        "data": {
            "timestamp": currentDateTime(),
            "message": {
                "type": "command",
                "topic": "session",
                "data": {
                    "action_info": "get",
                    "entity": {
                        "type": "initial_payload"
                    }
                }
            },
            "session_meta_data": {
                "to": {},
                "from": {}
            }
        }
    }
    requestInitialPayload(requestData);
}


export const initialDataLoadedAck = (serialNumber) => {
    let requestData = {
        "recipientId": serialNumber,
        "data": {
            "timestamp": currentDateTime(),
            "message": {
                "type": "acknowledgement",
                "topic": "session",
                "data": {
                    "label": "received",
                    "entity": {
                        "type": "initial_payload"
                    }
                }
            },
            "session_meta_data": {
                "to": {},
                "from": {}
            }
        }
    }
    sendAcknowldegeToSocket(requestData);
}

export const downloadLogsFile = (serialNumber,fileType) => {
    let requestData = {
        "recipientId": serialNumber,
        "data": {
            "timestamp": currentDateTime(),
            "message": {
                "type": "command",
                "topic": "file",
                "data": {
                    "action_info": "get",
                    "entity": {
                        "type": fileType
                    }
                }
            },
            "session_meta_data": {
                "to": {},
                "from": {}
            }
        }
    }
    sendCommandToSocket(requestData);
}


export const changeParamSettings = (serialNumber,updateParamArray) => {
    let request = {
      "recipientId": serialNumber,
      "data": {
          "timestamp": currentDateTime(),
          "message": {
              "type": "data_update",
              "topic": "parameter",
              "data": {
                  "operation_info": "update",
                  "entity": updateParamArray
              }
          },
          "session_meta_data": {
              "to": {},
              "from": {}
          }
      }
    }
    //console.log('param update from web',request);
    socket.emit('data_update',request);
}

export const sessionAcceptRequest = (event) => {
    let requestData = {
        "recipientId": 'session_request_pool',
        "data": {
            "timestamp": currentDateTime(),
            "message": {
                "type": "session_connection_request_accepted",
                "topic": "session_request_pool",
                "data": {
                    "room_id"  : event.target.value,
                    "row_id"   : event.target.getAttribute('data-id')
                }
            }
        }
    }
    sessionRequestAccepted(requestData);
}

export const sessionClosedRequest = (event) => {
    let requestData = {
        "recipientId": 'session_request_pool',
        "data": {
            "timestamp": currentDateTime(),
            "message": {
                "type": "session_connection_request_closed",
                "topic": "session_request_pool",
                "data": {
                    "room_id"  : event.target.value,
                    "row_id"   : event.target.getAttribute('data-id')
                }
            }
        }
    }
    sessionRequestEmitClosed(requestData);
}

export const socketRemoveListeners = () => {
    socket.removeAllListeners('change_logs');
    socket.removeAllListeners('events');
    socket.removeAllListeners('chat_messages');
    socket.off("change_logs", changeLogsRequest);
    socket.off("events", eventsRequest);
    socket.off("chat_messages", chatMessagesRequest);
    socket.removeAllListeners();
}

export const currentDateTime = () => {
    dayjs.extend(dayjsPluginUTC)
    return dayjs.utc().format('YYYY-MM-DD hh:mm:ss.SSS');
}


export const parameterValueUpdates = (parametersData,id,value) => {
    return parametersData.map(obj => {
        return {
            ...obj,
            parameters:obj.parameters.map(item => {
                if(item['id'] === id){
                    return {...item, value : value}
                }
                return item;
            })
        }
    });
}

export const favValueUpdates = async(favData,id,value) => {
    return favData.map(item => {
        if(item['id'] === id){
            return {...item, value : value}
        }
        return item;
    });
}

export const prepareUpdateData = async(parametersData,idsArray) => {
    let newArray = [];
    parametersData.map(element => element.parameters.map(ele =>  idsArray.includes(ele.id) ? newArray.push(ele) : '' ));
    return newArray;
}

export const beforeUnloadHandler =  (serialNumber) => {
    window.opener.sessionStorage.removeItem('connection');
    sessionStorage.removeItem('connection');
    sessionUnSubscribe(serialNumber);
    sessionDisconnect('disconnect'); 
}